"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BaseThumbnailGenerator", {
    enumerable: true,
    get: function() {
        return BaseThumbnailGenerator;
    }
});
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _stream = require("stream");
const _common = require("@nestjs/common");
const _slash = /*#__PURE__*/ _interop_require_default(require("slash"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let BaseThumbnailGenerator = class BaseThumbnailGenerator {
    /**
   * Generate thumbnails for the given file
   */ async generateThumbnails(file, relativePath, storageAdapter) {
        try {
            // Get the thumbnail buffer from the subclass
            const thumbnailBuffer = await this.generateThumbnailBuffer(file);
            const sharp = _Noco.default.sharp;
            const thumbnailPaths = {
                card_cover: _path.default.join('nc', 'thumbnails', relativePath, 'card_cover.jpg'),
                small: _path.default.join('nc', 'thumbnails', relativePath, 'small.jpg'),
                tiny: _path.default.join('nc', 'thumbnails', relativePath, 'tiny.jpg')
            };
            const sharpImage = sharp(thumbnailBuffer, {
                limitInputPixels: false
            });
            for (const [size, thumbnailPath] of Object.entries(thumbnailPaths)){
                let height;
                switch(size){
                    case 'card_cover':
                        height = 512;
                        break;
                    case 'small':
                        height = 128;
                        break;
                    case 'tiny':
                        height = 64;
                        break;
                    default:
                        height = 32;
                        break;
                }
                const resizedImage = await sharpImage.resize(undefined, height, {
                    fit: sharp.fit.cover,
                    kernel: 'lanczos3'
                }).jpeg({
                    quality: 80
                }).toBuffer();
                await storageAdapter.fileCreateByStream((0, _slash.default)(thumbnailPath), _stream.Readable.from(resizedImage), {
                    mimetype: 'image/jpeg'
                });
            }
            return thumbnailPaths;
        } catch (error) {
            this.logger.error({
                message: `Failed to generate thumbnails for ${relativePath}`,
                error: error == null ? void 0 : error.message
            });
            return null;
        }
    }
    constructor(){
        this.logger = new _common.Logger(this.constructor.name);
    }
};
